'use client';

import { logger } from '@/utils/loggerUtils';
import { ProductGroup } from '@vimond/services/rest-api/types';
import ProductGroupCard from './ProductGroupCard';

type ProductGroupsListProps = {
  highlightedProductGroupsIds: string[];
  onSelectProductGroup: (id: number) => void;
  productGroups: ProductGroup[];
};

export const ProductGroupsList = ({
  highlightedProductGroupsIds,
  onSelectProductGroup,
  productGroups,
}: ProductGroupsListProps) => {
  logger.log('ProductGroupsList -> Product groups: ', productGroups);
  logger.log(
    'ProductGroupsList -> productGroup.productsUri',
    productGroups.map((pg) => pg.productsUri),
  );
  const productGroupsWithHighlightedProperty = productGroups
    .map((productGroup) => ({
      ...productGroup,
      isHighlighted: highlightedProductGroupsIds.includes(`${productGroup.id}`),
    }))
    .sort((a, b) => {
      if (a.isHighlighted && !b.isHighlighted) {
        return -1;
      }
      if (!a.isHighlighted && b.isHighlighted) {
        return 1;
      }
      return 0;
    });
  return (
    <div className="flex flex-wrap w-full gap-4 items-center justify-center">
      {productGroupsWithHighlightedProperty.map((productGroup) => (
        <ProductGroupCard
          key={productGroup.id}
          productGroup={productGroup}
          onSelectProductGroup={onSelectProductGroup}
        />
      ))}
    </div>
  );
};
